import { Typography } from '@material-ui/core';
import { ColDef } from '@material-ui/data-grid';
import { useEffect, useState } from 'react'
import DataTable from '../../components/DataTable';
import api from '../../config/api'
import Loading from '../../components/Loading'
import * as yup from 'yup'
import { useForm} from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup';
import { toast } from 'react-toastify'
import {
    Container,
    ErrorMessage
} from './styles'
import {
    Button,
    TextField,
} from '@material-ui/core'

interface Branch {
    id: number
    description: string
    created_at: string
}

function Branchs() {

    const [branchs, setBranchs] = useState<Branch[]>([])
    const [loading, setLoading] = useState(false)
    const formCreateScheme = yup.object().shape({
        id: yup.string().required('É necessário informar o Id da agência'),
        description: yup.string().required('É necessário informar  nome da agência')
    })
    const { register, handleSubmit, formState: { errors }, reset } = useForm<{ id: number, description: string }>({
        resolver: yupResolver(formCreateScheme)
    })


    async function handleSubmitForm({ id, description }: { id: number, description: string }) {
        console.log('EIFNUWENF')
        try {
            const responseBranch = await api.post(`/branchs/`, { id, description })
            const { branch } = responseBranch.data
            setBranchs([...branchs,{
                id: branch.id,
                description: branch.description,
                created_at: '',
            }])
            reset()
            toast.success("Agência criada com sucesso!")
        } catch (err) {
            if (err instanceof Error){
                toast.error(err.message)
            }else
                toast.error('Erro desconhecido!')
        }
    }


    useEffect(() => {
        setLoading(true)
        async function fetch() {
            const response = await api.get('/branchs')
            setBranchs(response.data.branchs)
            setLoading(false)
        }
        fetch()
    }, [])

    const columns: ColDef[] = [
        { field: 'id', headerName: 'ID', width: 100 },
        { field: 'description', headerName: 'Nome', width: 300 }
    ];



    return (

        <Container>
            <form onSubmit={handleSubmit(handleSubmitForm)}>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                <TextField
                        autoComplete="fname"
                        variant="outlined"
                        id="id"
                        label="Numero da Unidade"
                        {...register('id')}
                        autoFocus
                        error={errors.description ? true : false}
                        style={{ width: 150 }}
                    />
                    <TextField
                        autoComplete="fname"
                        variant="outlined"
                        id="description"
                        label="Nome da Unidade"
                        {...register('description')}
                        autoFocus
                        error={errors.description ? true : false}
                        style={{ width: 350 }}
                    />
                    <Button
                        variant="contained"
                        type="submit"
                        color="secondary"
                        className="submit-button"
                        style={{
                            marginLeft:
                                10
                        }}>
                        Criar Agência
                     </Button>
                </div>
                {errors.description && <ErrorMessage>{errors.description.message}</ErrorMessage>}

            </form>
            {
                loading ?
                    <Loading />
                    :
                    <>
                        <Typography variant="h4" style={{ marginBottom: 10 , fontWeight: 600}}>
                            Lista de agências
                        </Typography>
                        <DataTable columns={columns} rows={branchs} />
                    </>
            }

        </Container>
    );
}

export default Branchs